import { ChangeEvent, forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { IFloatingFilterParams } from "ag-grid-community";
import { OptionObj } from "@/types/interfaces/common";
import IconButton from "@mui/joy/IconButton";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

interface Props extends IFloatingFilterParams {}

const SelectFloatingFilter = forwardRef((props: Props, ref) => {
  const [value, setValue] = useState("");

  useImperativeHandle(ref, () => {
    return {
      onParentModelChanged(parentModel: any) {
        if (parentModel) {
          setValue(parentModel.state);
        } else {
          setValue("");
        }
      },
    };
  });

  const handleChange = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;

    props.parentFilterInstance((instance: any) => {
      instance.setValue(newValue);
    });
  }, []);

  return (
    <>
      <select
        value={value}
        onChange={handleChange}
        style={{
          width: "100%",
          height: 32,
          borderRadius: "var(--ag-border-radius)",
          border: "var(--ag-borders-input) var(--ag-input-border-color)",
          alignSelf: "center",
          padding: 2,
          outline: "none",
        }}
      >
        {(props.filterParams as any)?.options.map((option: OptionObj) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {value && (
        <IconButton
          size="sm"
          sx={{
            ml: 1,
          }}
          onClick={() =>
            props.parentFilterInstance((instance: any) => {
              instance.setValue("");
            })
          }
        >
          <CloseOutlinedIcon />
        </IconButton>
      )}
    </>
  );
});

export default SelectFloatingFilter;
